export const enum ScrollAreaType {
    AUTO,
    ALWAYS,
    SCROLL,
    HIDDEN,
}

export const enum ScrollAreaDirection {
    HORIZONTAL,
    VERTICAL,
    BOTH,
}
